export default __webpack_public_path__ + "static/3_24-1a720821218be76c15ed59d7f7ea7af9.png";